import React, { useCallback, useEffect, useState } from "react";
import {
  Coins,
  ChevronDown,
  RefreshCw,
  Wallet,
  Landmark,
  Crown,
} from "lucide-react";
import "./NoticePanel.css";
import { useNavigate } from "react-router-dom";
import useTranslate from "../../hooks/useTranslate";

export default function NoticePanel({

  balance = "0.00",
  onLogin,
  onRegister,
  onDeposit,
  onWithdraw,
  onVip,
}) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslate();

  useEffect(() => {
    const checkLogin = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);
    };

    checkLogin();

    window.addEventListener("storage", checkLogin);
    window.addEventListener("auth-changed", checkLogin);

    return () => {
      window.removeEventListener("storage", checkLogin);
      window.removeEventListener("auth-changed", checkLogin);
    };
  }, []);

  const fetchBalance = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/balance`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (response.ok) {
          const data = await response.json();

          localStorage.setItem("balance", data.balance);
          if (document.querySelector(".mainBalance")) {
            document.querySelector(".mainBalance").innerHTML = data.balance;
          }
        } else if (response.status === 401) {
          // handleLogout();
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    } else {
      console.warn("No token found in local storage.");
    }
  }, []);
  return (
    <div className="notice-panel">
      {!isLoggedIn ? (
        <div className="auth-actions">
          <button className="auth-btn" type="button" onClick={onLogin}>
            {t("login")}
          </button>

          <button className="auth-btn" type="button" onClick={onRegister}>
            {t("register")}
          </button>
        </div>
      ) : (
        <>
          <div className="logged-panel">
            <div className="logged-balance-wrap">
              <div className="logged-balance-title">{t("totalBalance")}</div>

              <div className="logged-balance-row">
                <span className="balance-coin">
                  <Coins size={14} strokeWidth={2.4} />
                </span>

                <span className="balance-value">{balance}</span>

                <span className="balance-arrow">
                  <ChevronDown size={15} strokeWidth={2.5} />
                </span>

                <button
                  onClick={fetchBalance}
                  type="button"
                  className="balance-refresh"
                  aria-label={t("refreshBalance")}
                >
                  <RefreshCw size={18} strokeWidth={2.6} />
                </button>
              </div>
            </div>

            <div className="logged-shortcuts">
              <button
                type="button"
                className="shortcut-item"
                onClick={() => {
                  if (onDeposit) {
                    onDeposit();
                  } else {
                    navigate("/deposit");
                  }
                }}
              >
                <span className="shortcut-icon shortcut-blue">
                  <Wallet size={16} strokeWidth={2.2} />
                </span>
                <span className="shortcut-label">{t("deposit")}</span>
              </button>

              <button
                type="button"
                className="shortcut-item"
                onClick={() => {
                  if (onWithdraw) {
                    onWithdraw();
                  } else {
                    navigate("/withdrawal");
                  }
                }}
              >
                <span className="shortcut-icon shortcut-orange">
                  <Landmark size={16} strokeWidth={2.2} />
                </span>
                <span className="shortcut-label">{t("withdrawal")}</span>
              </button>

              <button
                type="button"
                className="shortcut-item"
                onClick={() => {
                  if (onVip) {
                    onVip();
                  } else {
                    navigate("/vip-bonus");
                  }
                }}
              >
                <span className="shortcut-icon shortcut-gold">
                  <Crown size={16} strokeWidth={2.2} />
                </span>
                <span className="shortcut-label">{t("vip")}</span>
              </button>
            </div>
          </div>

          <div className="wallet-actions">
            <button
              onClick={() => {
                if (onDeposit) {
                  onDeposit();
                } else {
                  navigate("/deposit");
                }
              }}
              className="auth-btn"
              type="button"
            >
              {t("deposit")}
            </button>

            <button
              onClick={() => {
                if (onWithdraw) {
                  onWithdraw();
                } else {
                  navigate("/withdrawal");
                }
              }}
              className="auth-btn"
              type="button"
            >
              {t("withdrawal")}
            </button>
          </div>
        </>
      )}
    </div>
  );
}